import React, { useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./AllForGallerySwitch.scss";
import { ThemeContext } from "../../store/ThemeProvider";
import BottomModal from "../ButtonGroup/BottomModal";
import Button from "../Common/Button";
import { inject, observer } from "mobx-react";
import RootStore from "../../store/RootStore";
import "../ComponentTab/CustomTab.scss";
import { OneTab } from "../ComponentTab/CustomTab";
import { renderGalleryType } from "../ComponentGallery/AllForGallery";
import { getPageSameType, isIphoneX } from "../../utils/util";
import {
  IComponent,
  IComponentVideo,
  IComponentGallery,
  IComponentCommentSend,
} from "../../component";
import RenderComponent, {
  RenderComponentWithWrapper,
} from "../Gallery/RenderComponent";
import SwipeableViews from "react-swipeable-views";
import ReactSVG from "react-svg";
import ComponentLink from "../ComponentLink";
import { alpha, getPendantColor } from "../../utils/color";
import intl from "react-intl-universal";
import stat from "../../utils/stat";
import useRealBottomTab from "../ComponentNavigator/useRealBottomTab";

interface ISwitchUp {
  onClick: () => void;
  h1Color?: string;
  mainColor?: string;
}
const SwitchUp = function (props: ISwitchUp) {
  const { backgroundColor, h1Color, mainColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);
  return (
    <div
      className="gallery-switch"
      onClick={props.onClick}
      style={{ color: pendantIconColor, backgroundColor: pendantBgColor }}
    >
      <div style={{ color: pendantIconColor }} className="icon-up-angle" />
      <div style={{ color: pendantIconColor }}>
        {intl.get("Switch Gallery")}
      </div>
    </div>
  );
};

interface IAllForGallerySwitch {
  rootStore?: RootStore;
}
const AllForGallerySwitch = function (props: IAllForGallerySwitch) {
  const { h1Color, mainColor, componentColor } = useContext(ThemeContext);
  const [showList, setShowList] = useState(false);
  const [galleryList, setGalleryList] = useState([] as IComponent[]);
  const [videoList, setVideoList] = useState([] as IComponent[]);
  const [switchShow, setSwitchShow] = useState(true); //是否显示Switch，默认是要显示
  const { pagedataStore, galleryStore } = props.rootStore!;
  //console.log(galleryList, videoList);
  const { parentLinkId } = pagedataStore;
  const [realBottom, setRealBottom] = useState(4);

  const { jigsaw } = galleryStore;
  // 如果当前是拼图底部已经显示的情况下，任何挂件都不需要显示
  const { bottomShow } = jigsaw;

  const setShowListAction = (flag: boolean) => {
    setShowList(flag);

    if (flag) {
      setTimeout(() => {
        setIndex(0);
      }, 150);
    } else {
      setIndex(-1);
    }
  };

  useEffect(() => {
    if (Number(window.pageDetail.parent)) {
      pagedataStore.getParentPgData(window.pageDetail!.link_id).then((dt: any) => {
        const { template, link_id } = dt;
        pagedataStore.setParentLinkId(link_id);

        const templateList = template;
        setGalleryList(
          getPageSameType(templateList as IComponent[], [], "gallery")
        );

        // 此处还需要过滤掉那些允许当前播放的视频内容
        let videoList = getPageSameType(
          templateList as IComponent[],
          [],
          "hvideolist"
        );
        setVideoList(
          videoList.filter((one: any) => {
            return !one.current_page_play;
          })
        );
      });
    }
  }, []);

  const [commentSendShow, setCommentSendShow] = useState(true);

  useEffect(() => {
    const eventHandler = (e: Event) => {
      if (e && e.type == "custom-commentsend-show") {
        setCommentSendShow(true);
      }
      if (e && e.type == "custom-commentsend-hide") {
        setCommentSendShow(false);
      }
    };

    window.addEventListener("custom-commentsend-show", eventHandler);
    window.addEventListener("custom-commentsend-hide", eventHandler);

    return () => {
      window.removeEventListener("custom-commentsend-show", eventHandler);
      window.removeEventListener("custom-commentsend-hide", eventHandler);
    };
  }, []);

  // 设置真实的距离底部的距离
  useEffect(() => {
    let { template } = window.pageDetail;
    let paddingBottom = 0;
    paddingBottom += 0 + (isIphoneX() ? 22 : 0);
    let shouldBorder = false;
    const { showNavigator } = useRealBottomTab();
    if (showNavigator) {
      paddingBottom += 49;
      shouldBorder = true;
    }
    const commentsend = getPageSameType(template, [], ["commentsend"]);
    if (commentsend && commentsend.length && commentSendShow) {
      paddingBottom += 66;

      // if (
      //   commentsend[0] &&
      //   Number((commentsend[0] as IComponentCommentSend).emotion)
      // ) {
      //   paddingBottom += 73;
      //   shouldBorder = true;
      // }
    }

    // if(shouldBorder) {
    //   paddingBottom += 15;
    // }

    setRealBottom(paddingBottom);
  }, [commentSendShow]);

  useEffect(() => {
    const shouldShowBottom = function (e: Event) {
      console.log(e.data);
      // 只有index === 0 才显示，否则不显示
      setSwitchShow(e.data === 0);
    };
    window.addEventListener("SWIPER_INDEX_CHANGE", shouldShowBottom, false);
    return () => {
      window.removeEventListener("SWIPER_INDEX_CHANGE", shouldShowBottom);
    };
  }, []);

  const [commentSendFocus, setCommentSendFocus] = useState(false);
  useEffect(() => {
    const eventHandler = (e: Event) => {
      if (e && e.type == "custom-commentsend-focus") {
        setCommentSendFocus(true);
      }
      if (e && e.type == "custom-commentsend-blur") {
        setCommentSendFocus(false);
      }
    };

    window.addEventListener("custom-commentsend-focus", eventHandler);
    window.addEventListener("custom-commentsend-blur", eventHandler);

    return () => {
      window.removeEventListener("custom-commentsend-focus", eventHandler);
      window.removeEventListener("custom-commentsend-blur", eventHandler);
    };
  });

  const [index, setIndex] = useState(-1);
  const tabs = [
    {
      title: intl.get("live-photo"),
    },
    {
      title: intl.get("live-video"),
    },
  ];

  const has2Lists = !!(galleryList.length && videoList.length);

  // 如果既没有gallery又没有video，这个不应该显示出来
  if (!galleryList.length && !videoList.length) {
    return null;
  }

  const returnHome = () => {
    // console.log('返回首页',parentLinkId);
    stat.event('switch_return');
    stat.send();
    ComponentLink.to(parentLinkId);
  };

  // 设计是让滚动内容的高度固定来着，所以最大高度需要手动计算一下了，尴尬
  const { clientHeight } = document.documentElement;
  const maxListHeight = clientHeight * 0.4;
  const margins = 15;
  const bottom = 2 * margins + 30 + 30;
  const tabHeight = 70; //图上拿到的
  const outerMaxHeight = maxListHeight + (has2Lists ? tabHeight : 0) + bottom;
  const filterGalleryCurrent = (galleries: IComponentGallery[]) => {
    let newGalleries = galleries.map((gallery) => {
      const { list = [] } = gallery;
      const newList = list.filter((one) => {
        const { link } = one;
        const { link_id = "" } = link;
        return link_id !== window.pageDetail.link_id;
      });
      gallery.list = newList;

      if (gallery && gallery.list && gallery.list.length) {
        return gallery;
      }
      return null;
    });
    return newGalleries.filter(Boolean) as IComponentGallery[];
  };

  const renderGalleryList = filterGalleryCurrent(
    galleryList as IComponentGallery[]
  );

  const renderChildren = () => {
    return (
      <div
        key="gallery-list"
        className="switch-gallery-list"
        style={{
          color: h1Color,
          backgroundColor: alpha(componentColor, 1),
          paddingTop: 10,
        }}
        id="gallery-switch"
      >
        {/*不知道为什么之前的判断has2Lists在div.tab-wrapper里边，这样的话，没有tab的时候显示这个有点多余*/}
        {has2Lists && (
          <div className="tab-wrapper">
            {tabs.map((tab, i) => (
              <OneTab
                key={i}
                name={tab.title}
                active={i === index}
                onClick={() => setIndex(i)}
                h1Color={h1Color}
                mainColor={mainColor}
              />
            ))}
          </div>
        )}
        <div className="list-wrapper">
          {/*注意，下面的galleryList和videoList的渲染不要使用RenderComponentWithWrapper的函数调用形式，
          会导致react渲染时报警告知hook的顺序不对：
          React has detected a change in the order of Hooks called by AllForGallerySwitch.
          请使用组件的形式，其他地方也请注意
          */}
          <SwipeableViews
            style={{ height: "100%", flex: 1 }}
            containerStyle={{
              height: "100%",
              WebkitOverflowScrolling: "touch",
            }}
            disabled={true}
            index={Math.max(0, index)}
            onChangeIndex={(i) => setIndex(i)}
          >
            {[
              renderGalleryList && renderGalleryList.length ? (
                <div key={0} onClick={() => {
                  stat.event('switch_page');
                  stat.send();
                }}>
                  {renderGalleryList.map((component, index) => {
                    return (
                      <React.Fragment key={index}>
                        <RenderComponentWithWrapper {...component} />
                      </React.Fragment>
                    );
                  })}
                </div>
              ) : null,
              videoList && videoList.length ? (
                <div key={1} onClick={() => {
                  stat.event('switch_page');
                  stat.send();
                }}>
                  {videoList.map((component, index) => {
                    return (
                      <React.Fragment key={index}>
                        <RenderComponentWithWrapper {...component} />
                      </React.Fragment>
                    );
                  })}
                </div>
              ) : null,
            ].filter(Boolean)}
          </SwipeableViews>
        </div>

        {window.custom_current_watermark ? null : <Button
          type={"primary"}
          radius={true}
          style={{
            marginBottom: margins,
            marginTop: margins,
            height: 35,
            padding: "0 40px",
            fontSize: 15,
          }}
          onClick={returnHome}
        >
          {intl.get("Switch Gallery")}
        </Button>}
        <div
          className="bottom-arrow-down"
          onClick={() => setShowListAction(false)}
        >
          <ReactSVG
            src={require("../../svg/right-arrow.svg")}
            className={"arrow-down"}
            style={{ fill: h1Color }}
          />
        </div>
      </div>
    );
  };

  return (
    <div
      className="all-for-gallery-switch"
      style={{
        bottom: realBottom,
        marginLeft: window.localStorage.getItem("lang") == "en-US" ? -50 : -34,
      }}
    >
      {!bottomShow && switchShow && !commentSendFocus ? (
        pagedataStore.renderMode == 'pc' ? (
          <div className="one-tab-name" onClick={() => {
            setShowListAction(true);
            stat.event("gallery_switch");
          }}>导航</div>
        ) : (
          <SwitchUp
            onClick={() => {
              setShowListAction(true);
              stat.event("gallery_switch");
            }}
          />
        )
      ) : null}
      {showList ? <BottomModal
        show={showList}
        showStyle={{ borderRadius: "4px 4px 0 0", maxHeight: outerMaxHeight }}
        onHide={() => setShowListAction(false)}
        onlyChild={true}
        child={renderChildren()}
        useMask={true}
        onMaskClick={() => setShowListAction(false)}
      /> : null}
    </div>
  );
};

export default inject("rootStore")(observer(AllForGallerySwitch));
